<template>
  <div class="search-tips-div">
    <div class="txt-top">
      您好，我是<span class="col-txt">iEP-智能助手，</span>能根据您输入的<span class="col-txt">关键词或问题</span>从iEP平台上检索出<span
      class="col-txt">最相关的</span>的内容。
    </div>
    <div class="txt-btm">
      相关内容仅供医疗专业人士之间进行学术交流目的使用，仅基于作者的经验总结和代表作者本人观点，任何情况下不得替代临床诊断。
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.search-tips-div {
  border-radius: 8px;
  background: rgb(249, 248, 247);
  margin-left: 14px;
  width: calc(100% - 28px);
  height: 90px;
  padding: 10px;
  box-sizing: border-box;

  .txt-top {
    line-height: 18px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 13px;
    color: #333333;
    margin-bottom: 4px;

    .col-txt {
      color: #EB1700;
    }
  }

  .txt-btm {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 10px;
    color: #333333;
    line-height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pageSearch/WelcomeTip.vue